<template>
<div class="order">
	<div class="order-top">
		<span v-if="info.policyVoucherNo||info.guaranteeNo">凭证号：</span>
		<a :href="detailUrl" target="_blank">{{info.policyVoucherNo||info.guaranteeNo||''}}</a>
		<span class="order-top-status">{{info.status||info.effectiveStatusDesc||''}}</span>
	</div>
	<div class="order-main">
		<div class="order-main-product border-right">
			<div class="order-main-product-right">
				<p class="ptitle">{{info.productName}}</p>
				<p class="com" v-if="info.scheme"> {{info.scheme}}</p>
				<p class="com">{{info.insuranceCompanyName}}</p>
			</div>
		</div>
		<div class="order-main-applicant w200 border-right">
			<p>权益持有人</p>
			<p class="atitle">{{info.companyName}}</p>
		</div>
		<div class="order-main-item border-right">
			<p>保障起期</p>
			<p class="atitle">{{info.effectiveDateStart}}</p>
		</div>
		<div class="order-main-item border-right">
			<p>保障止期</p>
			<p class="atitle">{{info.effectiveDateEnd}}</p>
		</div>
		<div class="order-main-item border-right">
			<p>保障期限</p>
			<p class="atitle">{{info.insuredPeriodName||(info.effectiveDays?`${info.effectiveDays}天`:'')}}</p>
		</div>
		<div class="order-main-premium border-right">
			<p>保费</p>
			<p class="price">{{info.amount||info.premium}} 元</p>
			<Button size="small" type="primary" v-if="info.productCode.indexOf('APP')==-1&&info.renew&&(this.info.productCode!='GSCGZZRX'&&(this.info.productCode!='GSCGZZRXPC'||this.info.productCode!='GSCGZZRXPCUPD'||this.info.productCode!='GSCGZZRXPCUPDA'))" @click="toRenewal(info.id)" >立即续保</Button>
		</div>
	</div>
</div>
</template>
<script>
export default {
	props:{
		info:Object,
		type:String
	},
	data () {
		return {
		}
	},
	computed: {
		detailUrl(){
			if(this.info.guaranteeNo){
				// 通用框架
				return `/haierProduct.html#/my/policy-detail/${this.info.id}/common`
			}else{
				return `/haierProduct.html#/my/policy-detail/${this.info.id}`
			}
		}
	},
	methods: {
		// 立即续保
		toRenewal(id) {
			if (this.info.productCode=='GSCGZZRX'||this.info.productCode=='GSCGZZRXPC'||this.info.productCode=='GSCGZZRXPCUPD'||this.info.productCode=='GSCGZZRXPCUPDA') location.href="/haierProduct.html#/company-group-employergs?renewId="+id+'&productCode=GSCGZZRXPCUPDA'
			else location.href="/haierProduct.html#/company-group-employer?renewId="+id+'&productCode='+this.info.productCode
		}
	},
}
</script>
<style scoped lang="less">
	.border-right{
		border-right:1px solid #eaeaea;
	}
	.order{
		border:1px solid #eaeaea;
		margin-top: 10px;
		&-top{
			padding: 10px;
			font-size: 14px;
			color:#aaa;
			border-bottom: 1px solid #eaeaea;
			height: 42px;
			&-status{
				float: right;
				color: #333;
			}
		}
		&-main{
			display:flex;
			text-align:center;
			height:110px;
			font-size: 14px;
			&-applicant,&-premium,&-item,&-status,&-btn{
				padding: 15px 10px;
				display:flex;
				align-items:center;
				justify-content:center;
				line-height:1.5;
				flex-wrap:wrap;
				width: 130px;
				p{
					width:100%;
				}
			}
			&-product{
				flex:1;
				min-width:240px;
				text-align:left;
				padding: 15px 10px;
				display:flex;
				align-items:center;
				&-img{
					width:60px;
					height:80px;
					font-size: 0;
					display:flex;
					align-items:center;
					img{
						width:100%;
						// height:100%;
					}
				}
				&-right{
					flex:1;
					p.ptitle{
						height:30px;
						white-space: nowrap;
						text-overflow: -o-ellipsis-lastline;
						overflow: hidden;
						text-overflow: ellipsis;
						font-size: 16px;
						font-weight: bold;
					}
					p.com{
						margin-top: 5px;
						color:#666;
						font-size: 14px;
					}
				}
			}
			&-btn{
				width:150px;
			}
			&-applicant{
				min-width:200px;
			}
			&-premium{
				white-space: nowrap;
			}
			&-status{
				width:150px;
			}
		}
	}
	.price{
		font-size: 18px;
		color:#FF6600;
		font-weight: bold;
	}
	.atitle{
		font-size: 14px;
		font-weight: bold;
	}
	span.icon{
		padding: 0 10px;
		cursor: pointer;
		transition:all .2s;
	}
	span.icon:hover{
		color:red;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/common/PolicyItem.vue